module.exports = __webpack_public_path__ + "static/img/OIP.4ac3e1f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/OIP.webp
// module id = mobO
// module chunks = 0